import { useState } from 'react';
import { signInWithRedirect } from 'aws-amplify/auth';
import useAuthToken from '../../hooks/useAuthToken';
import { handleSignOut } from '../../handlers/signOut';
import { CircularProgress, Button } from '@mui/material';
import * as CommonSectionTypes from '../components/CommonSectionLayout/CommonSectionTypes';
import { PUBLIC_SIGN_IN_ENABLED } from '../../constants/publicAuth';

const SLPInfluencersListPersonaBtn: React.FC<CommonSectionTypes.StartCreatingButtonProps> = ({
  maxHeight = '52px',
  padding = '16px 32px',
  marginTop = { xs: 0, md: '40px' }
}: CommonSectionTypes.StartCreatingButtonProps) =>
{
  const [isLoading, setLoading] = useState(false);
  const { isAuthenticated, isLoading: tokenLoading } = useAuthToken();

  const handleSignIn = async () => {
    if (isLoading || tokenLoading) return;
    try {
      setLoading(true);
      if (isAuthenticated) {
        await handleSignOut();
      }
      await signInWithRedirect({ provider: 'Google' });
    } catch (error) {
      console.error('signUp error', error);
    } finally {
      setLoading(false);
    }
  };

  if (!PUBLIC_SIGN_IN_ENABLED) return null;

  return (
    <Button
      onClick={handleSignIn}
      disabled={isLoading || tokenLoading}
      sx={{
        maxWidth: { sm: '160px', md: '200px' },
        maxHeight,
        fontSize: { sm: '14px', md: '16px' },
        marginTop,
        width: '100%',
        padding,
        borderRadius: '170px',
        boxShadow: '0px -4px 50px 0px rgba(11,87,208,0.68)',
        fontWeight: 'bold',
        background: 'linear-gradient(163deg, rgb(12, 174, 207) -29.1%, rgb(88, 15, 107) 96.45%)',
        color: 'white',
        textTransform: 'none',
        whiteSpace: 'nowrap'
      }}
    >
      {isLoading || tokenLoading ? (
        <CircularProgress size={24} sx={{ color: 'white' }} />
      ) : (
        'List your Persona'
      )}
    </Button>
  );
};

export default SLPInfluencersListPersonaBtn;
